
import Vue, { PropOptions } from 'vue';

export interface Tab {
    value: string | number;
    label: string;
}

export default Vue.extend({
    name: 'Tabs',
    props: {
        value: {
            type: [Number, String],
            required: true,
        },
        tabs: {
            // Value-Label pair
            type: Array,
            default: () => [],
        } as PropOptions<Tab[]>,

        withSearchParam: Boolean,
    },
    methods: {
        setSearchTab(value: string | number) {
            const url = new URL(window.location.href);
            url.searchParams.set('tab', value + '');
            window.history.replaceState(
                {
                    path: url.toString(),
                },
                '',
                url.toString()
            );
        },
        onChange(tab: Tab) {
            if (this.withSearchParam) this.setSearchTab(tab.value);

            this.$emit('input', tab.value);
        },
    },
});
